export default __webpack_public_path__ + "static/media/img_title.3fa57c49.png";